<template>
  <div class="data-query-container">
    <div class="show-query-container">
      <el-row
        v-for="(cItem, cIndex) in queryList"
        :key="cIndex"
        :gutter="20"
        align="middle"
        class="mt5"
        type="flex"
        style="width: 85%"
      >
        <el-col :span="6">
          <el-select
            v-model="cItem.formItemId"
            placeholder="请选择题目"
            @change="resetVal(cItem)"
            style="width: 100%"
            @focus="setOptionWidth"
          >
            <el-option
              v-for="item in getConditionProjectItemList()"
              :key="item.id"
              :label="item.questionNumber ? `${item.questionNumber}.${item.textLabel}` : item.textLabel"
              :value="item.formItemId"
              :style="{ width: selectOptionWidth }"
            />
          </el-select>
        </el-col>
        <el-col :span="4" v-if="cItem.formItemId">
          <el-select
            v-model="cItem.expression"
            placeholder="请选择条件"
            style="width: 100%"
            @change="resetVal(cItem, ['optionValue', 'saveOptionValueForCheckLabel'])"
          >
            <el-option
              v-for="item in getConditionOptions(cItem)"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-col>
        <!-- 条件值 -->
        <el-col :span="7" v-if="cItem.formItemId && !['is_null', 'not_null'].includes(cItem.expression)">
          <template v-if="getFormItemIdType(cItem.formItemId) === 'DATE'">
            <el-date-picker
              v-if="cItem.expression === 'between'"
              v-model="cItem.optionValue"
              type="daterange"
              @change="handleDateChange($event, cItem)"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              placeholder="请选择日期"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            <el-date-picker
              v-else
              v-model="cItem.optionValue"
              type="date"
              @change="handleDateChange($event, cItem)"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              placeholder="请选择日期"
            >
            </el-date-picker>
          </template>
          <el-cascader
            :ref="'cascader' + cIndex"
            v-else-if="['RADIO', 'CHECKBOX', 'SELECT', 'CASCADER'].includes(getFormItemIdType(cItem.formItemId))"
            :options="getFormItemOptions(cItem.formItemId)"
            :props="{ multiple: true }"
            @change="handleChangeCascader($event, cItem, cIndex)"
            v-model="cItem.saveOptionValueForCheckLabel"
            collapse-tags
            clearable
            placeholder="请选择"
            style="width: 100%"
          >
          </el-cascader>

          <el-input
            v-else
            style="width: 100%"
            clearable
            v-model="cItem.optionValue"
            :placeholder="inputPlaceholder(cItem.formItemId)"
            @input="changeValue($event, cItem)"
          />
        </el-col>
        <el-col :span="6">
          <el-button v-if="queryList.length < 15" type="text" @click="addQueryItem()">
            <i class="el-icon-circle-plus-outline" />
          </el-button>
          <el-button v-if="queryList.length > 1" class="remove" type="text" @click="handleRemoveLogicItem(cIndex)">
            <i class="el-icon-remove-outline" />
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { jsonSimpleClone } from '@/utils'
import { listProjectItemRequest } from '@/api/project/form'
import { debounce } from 'throttle-debounce'
import { componentTypes } from './config'

export default {
  name: 'DataQueryForm',
  components: {},
  props: {
    formKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      saveMessage: '',
      isSave: 'info',
      isLoading: false,
      // 默认逻辑结构
      defaultItem: {
        // 条件 == > < >= <=
        expression: null,
        // 题目
        formItemId: null,
        // 值
        optionValue: null,
        // 选项类型用到
        saveOptionValueForCheckLabel: null
      },
      componentTypes,
      allProjectItemList: [],
      queryList: [],
      activeItem: {},
      dialogVisible: false, // 包含关键词弹窗
      selectOptionWidth: '100%'
    }
  },
  watch: {
    formKey: function (val) {
      this.initQueryItem()
      if (val) {
        this.queryProjectItems()
      }
    }
  },
  mounted() {
    this.initQueryItem()
    this.queryProjectItems()
  },
  methods: {
    initQueryItem() {
      this.queryList = []
    },
    addQueryItem() {
      this.queryList.push(jsonSimpleClone(this.defaultItem))
    },
    // 获取连接类型
    getConditionOptions(cItem) {
      const formItemId = cItem.formItemId
      let opts = this.getOptions(formItemId)
      if (!cItem.expression) cItem.expression = opts[0].value
      return opts
    },
    getOptions(formItemId) {
      // 截取第一个数字前面的字符串
      let type = this.getFormItemIdType(formItemId)
      let componentTypes = jsonSimpleClone(this.componentTypes)
      const activedComponent = componentTypes.filter((item) => item.typeIds.includes(type))
      return activedComponent[0]?.conditionOptions
    },
    // 获取题目选项
    getConditionProjectItemList() {
      let componentTypeIds = Array.from(componentTypes, ({ typeIds }) => typeIds)
      let allTypeIds = []
      componentTypeIds.forEach((item) => {
        allTypeIds = [...item, ...allTypeIds]
      })
      return jsonSimpleClone(this.allProjectItemList).filter((item) => {
        return allTypeIds.includes(item.type)
      })
    },
    /**
     * 获取条件值选项
     * @param formItemId
     * @returns {*[]|*}
     */
    getFormItemOptions(formItemId) {
      let formItem = this.allProjectItemList.find((item) => item.formItemId == formItemId)
      if (formItem) {
        return formItem.scheme.config.options
      }
      return []
    },
    // 题目修改reset 条件、选项、显示项
    resetVal(cItem, keyMap = null) {
      keyMap = keyMap ? keyMap : ['expression', 'optionValue', 'saveOptionValueForCheckLabel']
      keyMap.forEach((key) => this.$set(cItem, key, null))
    },
    handleRemoveLogicItem(index) {
      this.queryList.splice(index, 1)
    },
    getFormItemIdType(formItemId) {
      if (!formItemId) return ''
      return formItemId
        .replace(/(\D+)\d+.*/, '$1')
        .toUpperCase()
        .split('LABEL')[0]
    },
    // 获取可筛选的问卷题目集合
    queryProjectItems() {
      listProjectItemRequest({ key: this.formKey }).then((res) => {
        const allQuestions = res.data.reduce((acc, group) => acc.concat(group.items), [])
        this.allProjectItemList = allQuestions.filter((item) => {
          const formItemId = item.formItemId.replace(/(\D+)\d+.*/, '$1').toUpperCase()
          if (['RADIO', 'CHECKBOX', 'SELECT', 'CASCADER'].includes(formItemId))
            item.formItemId = `${item.formItemId}label`
          return item.type !== 'PAGINATION'
        })
      })
    },
    handleChangeCascader(val, cItem, cIndex) {
      this.$nextTick(() => {
        const childNodes = this.$refs['cascader' + cIndex][0]?.getCheckedNodes(true)
        cItem.optionValue = childNodes.map((item) => [`'${item.label}'`])
      })
    },
    // 下拉框弹出时，设置弹框的宽度
    setOptionWidth(event) {
      this.$nextTick(() => {
        this.selectOptionWidth = event.target.parentNode.parentNode.clientWidth + 'px'
      })
    },
    handleDateChange(date, cItem) {
      if (Array.isArray(date)) {
        cItem.optionValue = [date[0] + ' 00:00:00', date[1] + ' 23:59:59']
      } else {
        cItem.optionValue = date + ' 23:59:59'
      }
    },
    // 滑块/数字组件只能输入数字 评分只能输入正数
    changeValue(value, cItem) {
      const { componentTypes } = this
      let type = this.getFormItemIdType(cItem.formItemId)
      const curComponent = componentTypes.filter((item) => item.typeIds.includes(type))[0]
      if (curComponent?.regExp) {
        if (['RATE', 'SLIDER', 'NPS'].includes(type)) {
          cItem.optionValue = curComponent.regExp.test(value) ? value : ''
          return
        }
        cItem.optionValue = curComponent.regExp.test(parseInt(value)) ? String(parseInt(value)).replace('.', '') : ''
      }
    },
    inputPlaceholder: function (formItemId) {
      let isNeedNum = ['RATE', 'SLIDER', 'NUMBER', 'NPS'].includes(this.getFormItemIdType(formItemId))
      return isNeedNum ? '请输入数字' : '请输入'
    }
  }
}
</script>

<style lang="scss" scoped>
.data-query-container {
  width: 100%;
  padding: 0 10px;
  display: flex;
  position: relative;
  overflow: hidden;

  .scrollbar-container {
    height: 100%;
  }
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.not-query-container {
  .el-icon-circle-plus-outline {
    font-size: 20px;
  }

  .label {
    font-size: 18px;
  }
}

.query-item-container {
  .tips {
    font-size: 14px;
    color: #aaa;
  }

  .label {
    font-size: 15px;
  }

  .remove {
    color: #ff4949;
  }
}

.show-query-container {
  padding: 10px 0 10px 20px;
  min-width: 100%;
  background-color: #fff;
  height: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 24px;
}

.query-item {
  position: relative;

  .query-item-delete {
    position: absolute;
    right: 20px;
    top: -15px;
    color: #ff4d4f;
    cursor: pointer;
  }
}
</style>
